import React from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";

import mq from "../../../helpers/media-queries";

import Arrow from "../../../assets/img/breadcrumbs-arrow.svg";

const El = styled.ul`
  ${mq("sm", "min")} {
    margin-top: ${rem(-30)};
    margin-bottom: ${rem(30)};
  }
`;

const BreadcrumbLink = styled.button`
  display: inline-block;
  font-size: ${rem(13)};
  font-family: Sans-serif;
  color: #5c5e62;
  padding: 0;
  padding-right: ${rem(30)};
  appearance: none;
  border: 0;
  background: none;
  position: relative;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:not(:last-of-type) {
    &:after {
      content: "";
      width: ${rem(9)};
      height: ${rem(12)};
      position: absolute;
      right: ${rem(10)};
      top: 50%;
      margin-top: ${rem(-6)};
      background: url(${Arrow});
      background-repeat: no-repeat;
    }
  }

  ${(props) =>
    props.active &&
    css`
      color: #2d71b6;
    `}
`;

const Breadcrumbs = ({ links }) => (
  <El>
    {links.map((item, index) => (
      <BreadcrumbLink disabled={item.active} active={item.active} key={index}>
        {item.title}
      </BreadcrumbLink>
    ))}
  </El>
);

export default Breadcrumbs;
